module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-120x120-1a29d47ffc8ef253f56856ce72c8a09b.png";